import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb7b1132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-full-w" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _createVNode(_component_van_tabbar, {
      class: "tabbar",
      "z-index": 500,
      fixed: "",
      placeholder: "",
      "active-color": "#FD5C02",
      route: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabbarData, (item) => {
          return (_openBlock(), _createBlock(_component_van_tabbar_item, {
            key: item.route,
            icon: item.icon,
            to: item.route,
            replace: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.text), 1)
            ]),
            _: 2
          }, 1032, ["icon", "to"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}